import { IconShipping16 } from "@warp-ds/icons/react/shipping-16";
import React from "react";
import { Label } from "../../types/SemanticAd";
import { RecommerceAd } from "../types";

export const SHIPPING_LABEL_IDS = ["seller_pays_shipping", "shipping_exists"];

export type LabelRenderProps = {
	labels?: Label[];
	className?: string;
};

type AdLabelProps = {
	ad: RecommerceAd;
	className?: string;
};

export function AdLabel(props: AdLabelProps) {
	const { ad, className } = props;
	const label = getFirstMatchingLabel(ad.labels);

	if (!label) return null;

	const colorClass = label.id === "seller_pays_shipping" ? "s-text-positive" : "s-text-subtle";

	return (
		<span className={`flex items-center font-bold text-detail ${colorClass} ${className}`}>
			{(label.id === "seller_pays_shipping" || label.id === "shipping_exists") && <IconShipping16 className="mr-4" />}
			{label.text}
		</span>
	);
}

export const dotStyle: React.CSSProperties = {
	fontSize: "0.50em",
};

function getFirstMatchingLabel(labels: Label[] | undefined): Label | null {
	if (!labels) return null;

	const matchingLabels = labels.filter((label) => SHIPPING_LABEL_IDS.includes(label.id));

	if (matchingLabels.length === 0) return null;

	return matchingLabels.sort((a, b) => SHIPPING_LABEL_IDS.indexOf(a.id) - SHIPPING_LABEL_IDS.indexOf(b.id))[0];
}
